import ClientGroupOverviewViewModel from './clientGroupOverviewViewModel'

export default class ClientGroupOverviewWithFillRateViewModel extends ClientGroupOverviewViewModel {
  constructor({
    address = null,
    clientId,
    clientName,
    locationId,
    locationName,
    openBookings = 0,
    totalBookings = 0,
  } = {}) {
    super({
      address,
      clientId,
      clientName,
      locationId,
      locationName,
      openBookings,
      totalBookings,
    })

    this.filledBookings = totalBookings - openBookings

    let fillRatePercentage = -1

    if (!totalBookings && !openBookings) {
      fillRatePercentage = -1
    } else {
      const percentage = ((totalBookings - openBookings) / totalBookings) * 100

      const normalisedPercentage =
        percentage <= 0 || isNaN(percentage) ? 0 : percentage

      fillRatePercentage = Math.round(normalisedPercentage)
    }

    /**
     * A rounded percent of the number of bookings filled for this location
     * @type {Number}
     */
    this.fillRatePercentage = fillRatePercentage
  }
}
